import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function AddSubscription() {
  const [userId, setUserId] = useState(null);
  const [userType, setUserType] = useState("premium");
  const [cityIds, setCityIds] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userList, setUserList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Manage dropdown visibility
  const dropdownRef = useRef(null); // To handle clicks outside dropdown

  const [isDropdownLocationOpen, setIsDropdownLocationOpen] = useState(false);
  const [isDropdownPropertyTypeOpen, setIsDropdownPropertyTypeOpen] =
    useState(false);
  const dropdownLocationRef = useRef(null);
  const dropdownPropertyTypeRef = useRef(null);
  const [locationIds, setLocationIds] = useState([]);
  const [propertyTypeIds, setPropertyTypeIds] = useState([]);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [localities, setLocalities] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [subscriptionType, setSubscriptionType] = useState("");

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("HYT31", res.data);

      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
          setSelectedCity(userCity);
          fetchLocalities(userCity);
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      console.log("HYT71", res.status, cityId);

      if (res?.status) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  // Fetch PropertyType
  const fetchPropertyTypes = async () => {
    try {
      const res = await HomeService.getPropertyTypes();
      console.log("MNB83", res.data);

      if (res?.status) {
        setPropertyTypes(res.data);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const fetchUserList = async (type) => {
    try {
      let response;
      if (type === "basic") {
        response = await HomeService.getBasicUsers();
      } else {
        response = await HomeService.getUsers();
      }

      const usersData = response?.data || [];
      if (userCity) {
        const filterUsers = usersData.filter(
          (item) => (item?.city?._id || item?.city) === userCity,
        );
        const formattedUsers = filterUsers?.map((item) => ({
          value: item?._id,
          label: `${item?.fullName} - ${item?.email}`,
        }));
        setUserList(formattedUsers);
      } else {
        setUserList(
          usersData.map((item) => ({
            value: item?._id,
            label: `${item?.fullName} - ${item?.email}`,
          })),
        );
      }
    } catch (error) {
      toast.error("Failed to fetch user list.");
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUserList(userType);
    setUserId(null);
  }, [userType]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const citiesResponse = await HomeService.getCities();
        setCityList(citiesResponse?.data || []);
      } catch (error) {
        toast.error("Failed to fetch city list.");
        console.error("Error fetching data:", error);
      }
    };
    fetchData();

    // Close dropdown if clicked outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    // Close dropdown if clicked outside
    const handleClickLocationOutside = (event) => {
      if (
        dropdownLocationRef.current &&
        !dropdownLocationRef.current.contains(event.target)
      ) {
        setIsDropdownLocationOpen(false);
      }
    };

    const handleClickPropertyTypeOutside = (event) => {
      if (
        dropdownPropertyTypeRef.current &&
        !dropdownPropertyTypeRef.current.contains(event.target)
      ) {
        setIsDropdownPropertyTypeOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("mousedown", handleClickLocationOutside);
    document.addEventListener("mousedown", handleClickPropertyTypeOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleClickLocationOutside);
    };
  }, []);

  useEffect(() => {
    fetchCities();
    fetchPropertyTypes();
  }, []);

  useEffect(() => {
    fetchLocalities(selectedCity);
  }, [selectedCity]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        toast.error("Start date cannot be greater than end date!");
        return;
      }
    }

    // console.log("userId", userId);
    // return;

    const data = {
      // userId: userId,
      // cityId: cityIds,
      // startDate: startDate.split("T")[0],
      // endDate: endDate.split("T")[0],

      // userId: userId,
      userId: userId?.value,
      cityId: [selectedCity],
      // locality: selectedLocality,
      locality: locationIds,
      propertyType: propertyTypeIds,
      // price: parseInt(amount),
      price: Number(amount),
      startDate: startDate.split("T")[0],
      endDate: endDate.split("T")[0],
      date: date.split("T")[0],
      remarks: remarks,
      addedBy: loggedUserID,
      subscriptionType: subscriptionType,
      // cityId:cityIds,
    };

    console.log("KIU136", data);
    // return

    try {
      const res = await HomeService.addSubscription(data);

      if (res?.status) {
        toast.success("Subscription added successfully!");
        clearForm();
        navigate("/manage-subscription"); // Replace with appropriate route
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error("Failed to add subscription.");
      console.error("Error adding subscription:", error);
    }
  };

  const clearForm = () => {
    setUserId([]);
    setCityIds([]);
    setStartDate("");
    setEndDate("");
    setSubscriptionType("");
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setCityIds(
      (prevCities) =>
        prevCities.includes(value)
          ? prevCities.filter((_id) => _id !== value) // Remove if already selected
          : [...prevCities, value], // Add if not selected
    );
  };

  const [allSelected, setAllSelected] = useState(false);
  const handleSelectAllLocations = (e) => {
    console.log("JUY189", localities, locationIds, e.target.value);
    let allLocalities = localities.map((item) => item._id);
    if (allSelected) {
      allLocalities = [];
    }
    setLocationIds(allLocalities);
    setAllSelected(!allSelected);
  };

  const [allSelectedPropertyType, setAllSelectedPropertyType] = useState(false);
  const handleSelectAllPropertyType = (e) => {
    // console.log("JUY189", localities, locationIds, e.target.value);
    let allPropertyTypes = propertyTypes.map((item) => item._id);
    if (allSelectedPropertyType) {
      allPropertyTypes = [];
    }
    setPropertyTypeIds(allPropertyTypes);
    setAllSelectedPropertyType(!allSelectedPropertyType);
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocationIds(
      (prev) =>
        prev.includes(value)
          ? prev.filter((_id) => _id !== value) // Remove if already selected
          : [...prev, value], // Add if not selected
    );
    setAllSelected(false);
  };

  const handlePropertyTypeChange = (e) => {
    const value = e.target.value;
    setPropertyTypeIds(
      (prev) =>
        prev.includes(value)
          ? prev.filter((_id) => _id !== value) // Remove if already selected
          : [...prev, value], // Add if not selected
    );
    setAllSelectedPropertyType(false);
  };

  // const toggleDropdown = () => {
  //   setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown visibility
  // };

  const toggleDropdownLocation = () => {
    setIsDropdownLocationOpen(!isDropdownLocationOpen); // Toggle dropdown visibility
  };

  const toggleDropdownPropertyType = () => {
    setIsDropdownPropertyTypeOpen(!isDropdownPropertyTypeOpen); // Toggle dropdown visibility
  };

  const formatDateForDisplay = (date) => {
    if (!date) return ""; // Handle empty or invalid dates
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Subscription
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label style={{ marginRight: "15px", fontWeight: "600" }}>
                    User Type:
                  </label>
                  <div
                    className="form-check form-check-inline"
                    style={{ display: "inline-block", marginRight: "15px" }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="premiumUserRadio"
                      value="premium"
                      checked={userType === "premium"}
                      onChange={() => setUserType("premium")}
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="premiumUserRadio"
                      style={{ cursor: "pointer" }}
                    >
                      All User
                    </label>
                  </div>
                  <div
                    className="form-check form-check-inline"
                    style={{ display: "inline-block" }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="basicUserRadio"
                      value="basic"
                      checked={userType === "basic"}
                      onChange={() => setUserType("basic")}
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="basicUserRadio"
                      style={{ cursor: "pointer" }}
                    >
                      Basic User
                    </label>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  {/* <select
                    id="user"
                    className="form-control"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    required
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName}-<h6>{user.email}</h6>
                      </option>
                    ))}
                  </select> */}

                  {/* <Select options={userList} onChange={() => setUserId()} /> */}
                  <Select
                    options={userList}
                    onChange={(selectedOption) => setUserId(selectedOption)}
                    placeholder="Select User"
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Amount<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="form-control"
                    value={amount}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setAmount(e?.target?.value);
                      }
                    }}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    Cities<span className="text-danger">*</span>
                  </label>
                  {/* <div className="dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdown}
                    >
                      {cityIds.length === 0
                        ? "Select Cities"
                        : `${cityIds.length} cities selected`}
                    </button>
                    {isDropdownOpen && (
                      <div className="dropdown-menu-for-city">
                        {cityList.map((city) => (
                          <div key={city._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${city._id}`} // Properly linking with label
                              value={city._id}
                              checked={cityIds.includes(city._id)}
                              onChange={handleCityChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${city._id}`} // Linking label to input for accessibility
                              className="form-check-label"
                            >
                              {city.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div> */}
                  <select
                    className="form-control"
                    value={selectedCity}
                    onChange={(e) => {
                      setSelectedCity(e.target.value);
                      setLocationIds([]);
                    }}
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Locality<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown" ref={dropdownLocationRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdownLocation}
                    >
                      {locationIds.length === 0
                        ? "Select Locations"
                        : `${locationIds.length} locations selected`}
                    </button>
                    {isDropdownLocationOpen && (
                      <div className="dropdown-menu-for-city">
                        {localities.length > 0 && (
                          <div
                            className="form-check"
                            style={{
                              borderBottom: "solid 1px #eee",
                            }}
                          >
                            <input
                              type="checkbox"
                              id="s_all" // Properly linking with label
                              value="all"
                              checked={allSelected}
                              onChange={handleSelectAllLocations}
                              className="form-check-input"
                            />
                            <label className="form-check-label">
                              Select all
                            </label>
                          </div>
                        )}
                        {localities.map((item) => (
                          <div key={item._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${item._id}`} // Properly linking with label
                              value={item._id}
                              checked={locationIds.includes(item._id)}
                              onChange={handleLocationChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${item._id}`} // Linking label to input for accessibility
                              className="form-check-label"
                            >
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}

                <div className="col-md-6 mt-3">
                  <label htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                    onKeyDown={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    onKeyDown={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    onKeyDown={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                </div>

                {/* Property Types */}
                <div className="col-md-6 mt-3">
                  <label>
                    Property Type<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown" ref={dropdownPropertyTypeRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdownPropertyType}
                    >
                      {propertyTypeIds.length === 0
                        ? "Select property type"
                        : `${propertyTypeIds.length} property types selected`}
                    </button>
                    {isDropdownPropertyTypeOpen && (
                      <div className="dropdown-menu-for-city">
                        {propertyTypes.length > 0 && (
                          <div
                            className="form-check"
                            style={{
                              borderBottom: "solid 1px #eee",
                            }}
                          >
                            <input
                              type="checkbox"
                              id="s_all" // Properly linking with label
                              value="all"
                              checked={allSelectedPropertyType}
                              onChange={handleSelectAllPropertyType}
                              className="form-check-input"
                            />
                            <label className="form-check-label">
                              Select all
                            </label>
                          </div>
                        )}
                        {propertyTypes.map((item) => (
                          <div key={item._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`propertyType-${item._id}`} // Properly linking with label
                              value={item._id}
                              checked={propertyTypeIds.includes(item._id)}
                              onChange={handlePropertyTypeChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`propertyType-${item._id}`} // Linking label to input for accessibility
                              className="form-check-label"
                            >
                              {item.propertyType}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="subscriptionType">Subscription Type</label>
                  <select
                    id="subscriptionType"
                    className="form-control"
                    value={subscriptionType}
                    onChange={(e) => setSubscriptionType(e.target.value)}
                  >
                    <option value="">Select Type (None)</option>
                    <option value="basic">Basic</option>
                    <option value="premium">Premium</option>
                  </select>
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="remarks">Remarks</label>
                  {/* <input
                    type="text"
                    id="endDate"
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  /> */}
                  <textarea
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>
              </div>

              <button
                type="submit"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                }}
                className="btn mt-3"
              >
                Add Subscription
              </button>
              {/* <Link to="/manage-subscription">View Subscriptions</Link> */}
              <button
                type="submit"
                style={{
                  background: "#fff",
                  border: "solid 2px #85da4f",
                  borderRadius: "13px",
                  margin: "0 10px",
                }}
                className="btn mt-3"
                onClick={() => {
                  navigate("/manage-subscription");
                }}
              >
                View Subscriptions
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddSubscription;
